function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import { Field as FormikField, Form, ErrorMessage } from '../../../_snowpack/pkg/formik.js'; // @ts-ignore

import { Button } from '../../css/index.js'; // @ts-ignore

import is from '../../../_snowpack/pkg/styled-is.js'; // @ts-ignore

import { ContentPaper } from '../../modules/layout/main/index.js';
import { colors } from '../../css/index.js'; // @ts-ignore

export const Container = styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1ltntd5-0"
})(["flex:4 1 auto;margin-top:2rem;display:flex;flex-direction:column;"]);
export const H2 = styled.h2.withConfig({
  displayName: "styles__H2",
  componentId: "sc-1ltntd5-1"
})(["color:#4c505b;font-size:30px;font-family:'Roboto Slab',sans-serif;margin:0;"]);
export const BORDER = '2px dashed #0000001a';
export const Header = styled.header.withConfig({
  displayName: "styles__Header",
  componentId: "sc-1ltntd5-2"
})(["display:flex;flex-direction:row;align-items:flex-end;flex:1 1 auto;padding-bottom:20px;justify-content:space-between;padding-top:40px;"]);
export const Description = styled.div.withConfig({
  displayName: "styles__Description",
  componentId: "sc-1ltntd5-3"
})([""]);
export const Headline = styled.div.withConfig({
  displayName: "styles__Headline",
  componentId: "sc-1ltntd5-4"
})(["max-width:800px;"]);
export const Heading = styled.h2.withConfig({
  displayName: "styles__Heading",
  componentId: "sc-1ltntd5-5"
})(["color:", ";font-size:30px;font-style:normal;font-weight:bold;line-height:40px;margin:0 0 10px;"], ({
  theme
}) => theme.colors.density);
export const SubText = styled.p.withConfig({
  displayName: "styles__SubText",
  componentId: "sc-1ltntd5-6"
})(["color:", ";font-family:'Roboto',sans-serif;font-size:16px;font-style:normal;font-weight:normal;max-width:800px;margin:0;line-height:1.4em;padding-bottom:10px;"], ({
  theme
}) => theme.colors.density);
export const Image = styled.img.withConfig({
  displayName: "styles__Image",
  componentId: "sc-1ltntd5-7"
})(["width:150px;"]);
export const Text = styled.p.withConfig({
  displayName: "styles__Text",
  componentId: "sc-1ltntd5-8"
})(["margin:0;padding:10px 0 0;font-size:14px;line-height:1.5em;color:#4c505b;"]);
export const Wrapper = styled(ContentPaper).withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-1ltntd5-9"
})([""]);
export const ListItem = styled.li.withConfig({
  displayName: "styles__ListItem",
  componentId: "sc-1ltntd5-10"
})(["background-color:#fff;border-radius:25px;padding:0.25em 0.5em;margin:2px 0;font-size:14px;display:grid;grid-template-columns:", ";align-items:center;"], props => props.columns ? props.columns : '1fr 4fr 1fr');
export const List = styled.ul.withConfig({
  displayName: "styles__List",
  componentId: "sc-1ltntd5-11"
})(["width:100%;list-style:none;margin:0;padding:0;"]);
export const Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1ltntd5-12"
})(["display:flex;flex-direction:row;", " ", " padding:3rem 0;"], is('borderTop')`
    border-top: ${BORDER};
  `, is('borderBottom')`
    border-bottom: ${BORDER};
  `);
export const Outer = styled.div.withConfig({
  displayName: "styles__Outer",
  componentId: "sc-1ltntd5-13"
})(["grid-area:content;padding-top:1.5rem;"]);
export const DialogWrapper = styled.div.withConfig({
  displayName: "styles__DialogWrapper",
  componentId: "sc-1ltntd5-14"
})(["display:flex;flex-direction:column;padding:1rem;max-width:800px;hr{width:100%;}.x-crystallize{display:grid;grid-template-columns:1fr 2fr;grid-column-gap:10px;.x-crystallize-label{color:", ";}}button{margin:1rem 0;max-width:fit-content;align-self:flex-end;}"], colors.defrost);
const StyledCell = styled.span.withConfig({
  displayName: "styles__StyledCell",
  componentId: "sc-1ltntd5-15"
})(["", " ", " ", " overflow:", ";display:grid;padding:15px 25px;grid-template-rows:25px 28px;font-size:16px;color:", ";font-weight:500;border-left:1px solid #dfdfdf;&:first-of-type{border-left:1px solid transparent;}&:before{content:attr(data-label);font-size:14px;color:", ";font-weight:500;padding-bottom:10px;}&.xs{font-size:12px;}&.sm{font-size:14px;}&.md{font-size:16px;}&.lg{font-size:18px;}&.xl{font-size:18px;}"], ({
  align
}) => align === 'right' && 'justify-self: flex-end;', ({
  align
}) => align === 'left' && 'justify-self: flex-start;', ({
  align
}) => align === 'center' && 'justify-self: center;', props => props.overflow, ({
  theme
}) => theme.colors.density, ({
  theme
}) => theme.colors.label);
export const Cell = ({
  align,
  overflow,
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(StyledCell, _extends({
    align: align,
    overflow: overflow
  }, rest), children);
};
export const Row = styled.div.withConfig({
  displayName: "styles__Row",
  componentId: "sc-1ltntd5-16"
})(["color:", ";display:grid;background:#fff;box-shadow:", ";margin-bottom:5px;grid-template-columns:", ";align-items:center;border-radius:8px;"], ({
  theme
}) => theme.colors.frostbite, ({
  theme
}) => theme.dropShadow.md, ({
  columns
}) => columns !== null && columns !== void 0 ? columns : 'repeat(4, 1fr)');
export const FormikForm = styled(Form).withConfig({
  displayName: "styles__FormikForm",
  componentId: "sc-1ltntd5-17"
})(["width:100%;max-width:800px;h2{color:", ";}p{color:", ";line-height:1.4em;font-size:16px;max-width:700px;}"], ({
  theme
}) => theme.colors.density, ({
  theme
}) => theme.colors.density);
export const FieldGroup = styled.div.withConfig({
  displayName: "styles__FieldGroup",
  componentId: "sc-1ltntd5-18"
})(["padding:15px 25px;position:relative;border-right:1px solid #dfdfdf;min-width:150px;display:flex;flex-direction:column;&:last-of-type{border-right:0px solid #dfdfdf;}&:first-of-type{padding-left:35px;}&:focus-within{background:rgba(0,0,0,0.02);}"]);
export const FormGroup = styled.div.withConfig({
  displayName: "styles__FormGroup",
  componentId: "sc-1ltntd5-19"
})(["border:1px solid #dfdfdf;border-radius:8px;box-shadow:", ";display:flex;margin-top:50px;"], ({
  theme
}) => theme.dropShadow.md);
export const Field = styled(FormikField).withConfig({
  displayName: "styles__Field",
  componentId: "sc-1ltntd5-20"
})(["border:none;text-align:center;font-family:Roboto,sans-serif;font-size:16px;outline:none;position:relative;text-align:left;padding:10px 0;font-weight:500;width:100%;display:block;background:transparent !important;&:hover{background:transparent;}&:disabled{cursor:not-allowed;opacity:0.4;}&::placeholder{font-size:16px;font-style:italic;color:", ";}"], ({
  theme
}) => theme.colors.label);
export const SaveButton = styled(Button).withConfig({
  displayName: "styles__SaveButton",
  componentId: "sc-1ltntd5-21"
})(["margin:0px 0 0 auto;"]);
export const FieldError = styled(ErrorMessage).withConfig({
  displayName: "styles__FieldError",
  componentId: "sc-1ltntd5-22"
})(["font-size:12px !important;font-weight:400;color:", " !important;width:100%;position:absolute;bottom:5px;left:25px;min-height:auto;padding-left:0 !important;"], ({
  theme
}) => theme.colors.anion);